import React from "react"

export default function OtherPage() {
    return (
        <div className="other-page">
            <h1>I'm a new page!</h1>
        </div>
    )
}